import React from 'react';
import styled from 'styled-components';
import { CheckOutlined, CopyOutlined } from '@ant-design/icons';
import { Tooltip } from 'antd';
import MenuItem from 'antd/lib/menu/MenuItem';
import { ANTD_GRAY } from '../../../entity/shared/constants';
import { useTranslation } from '../../../../i18n/useTranslation';

interface CopyUrnMenuItemProps {
    urn: string;
    key: string;
    type: string;
    isCopied: boolean;
    onCopy: (str) => void;
}

const StyledMenuItem = styled(MenuItem)`
    && {
        width: 100%;
        color: ${ANTD_GRAY[8]};
        background-color: ${ANTD_GRAY[1]};
    }
`;

const TextSpan = styled.span`
    padding-left: 12px;
`;

export default function CopyUrnMenuItem(props: CopyUrnMenuItemProps) {
    const { t } = useTranslation();
    const { urn, type, isCopied, onCopy } = props;

    return (
        <StyledMenuItem
            {...props}
            onClick={() => {
                navigator.clipboard.writeText(urn);
                onCopy('URN');
            }}
        >
            <Tooltip
                placement="right"
                title={t('Copy the URN for this {{type}}. An URN uniquely identifies an entity on Data Catalog.', {
                    type,
                })}
            >
                {isCopied ? <CheckOutlined /> : <CopyOutlined />}
                <TextSpan>
                    <b>{t('Copy URN')}</b>
                </TextSpan>
            </Tooltip>
        </StyledMenuItem>
    );
}
